export default __webpack_public_path__ + "static/media/tax.d7ba4174.svg";